var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"navbar__wrapper"},[_c('div',{staticClass:"navbar__logo"},[_c('div',{staticClass:"navbar__logo-image"},[_c('r-logo',{attrs:{"size":32}})],1),_c('profiles-menu')],1),_c('navbar-router'),_c('navbar-actions')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }